// ---------------------------------------------------------------------------
// Toggle — slider on/off reutilizável do drawer V3.
// ---------------------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";
import useDrawerStyles from "./styles";
import useThemeColors from "../../../../hooks/useThemeColors";

const Toggle = ({ checked, onChange, label, name, disabled }) => {
  const { clientColor } = useThemeColors();
  const classes = useDrawerStyles({ clientColor });
  return (
    <label
      className={`${classes.toggle} ${disabled ? classes.toggleDisabled : ""}`}
    >
      <input
        type="checkbox"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange && onChange(e.target.checked)}
        className={classes.toggleInput}
      />
      <span
        className={`${classes.toggleSlider} ${
          checked ? classes.toggleSliderOn : ""
        }`}
      />
      {label && <span className={classes.toggleLabel}>{label}</span>}
    </label>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.node,
  name: PropTypes.string,
  disabled: PropTypes.bool,
};

Toggle.defaultProps = {
  disabled: false,
};

export default Toggle;
